import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import MessageBox from "./MessageBox";
import api from "../services/api.service";
import * as Styles from "../styles/Payback.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";
import { set } from "date-fns";

interface PaybackModalProps {
  isOpen: boolean;
  paybackValue: number;
  setSearchValueInput: (searchValue: string) => void;
  setCustomerInfoByOrder: (customerInfo: any) => void;
  onRequestClose: () => void;
}

const PaybackModal: React.FC<PaybackModalProps> = ({
  isOpen,
  paybackValue,
  setSearchValueInput,
  setCustomerInfoByOrder,
  onRequestClose,
}) => {
  const {
    subsidiaryDataZustand,
    setOrderDataZustand,
    orderDataZustand,
    setMessageZustand,
  } = useCombinedStore((state) => {
    return {
      subsidiaryDataZustand: state.subsidiaryDataZustand,
      setOrderDataZustand: state.setOrderDataZustand,
      orderDataZustand: state.orderDataZustand,
      setMessageZustand: state.setMessageZustand,
    };
  });

  const modalWrapperRef = useRef<HTMLDivElement>(null);
  const inputTrocoRef = useRef<HTMLInputElement>(null);

  const [troco, setTroco] = useState(0);
  const [payback, setPayback] = useState(paybackValue);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    const cashPaymentMethodUuid = subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodPayments?.PaymentMethods.find(
      (paymentMethod: any) => paymentMethod.paymentMethodType === "cash"
    )?.paymentMethodUuid;
    try {
      api.post(`addOrderPayment/${orderDataZustand.orderUuid}`, {
        payments: [{
          paymentMethodUuid: cashPaymentMethodUuid,
          value: Number(orderDataZustand.totals?.total?.replace(",", ".")) + Number(payback),
        }],
      });
      api.post(`closeOrder/${orderDataZustand.orderUuid}`);
      if (troco > 0) {
        api.post(`periodPayback/${subsidiaryDataZustand.selectedPdv.selectedPeriod.periodUuid}`, {
          periodInfoValue: troco,
        });
      }
    } catch (error: any) {
      if (error.message === "Network Error") {
        setMessageZustand(
          `Erro ao registrar pagamento, entre em contato com os administradores do Alfredo da sua unidade.`,
          `error`
        );
      } else {
        setMessageZustand(
          `Erro ao registrar pagamento: ${error.message}`,
          `error`
        );
      }
    }
    setMessageZustand(`Conta encerrada com sucesso!`, `success`);
    setSearchValueInput("");
    setOrderDataZustand({
      orderUuid: "",
      orderCode: "",
      orderOwnerUuid: "",
      orderOwnerName: "",
      orderStatus: 0,
      orderType: "",
      createdAt: "",
      orderInfo: {},
    });
    setCustomerInfoByOrder({
      customerName: "",
      customerAddress: "",
      customerAddressComplement: "",
      customerAddressObservation: "",
      customerOrigin: "",
      customerPhone: "",
    });
    setTroco(0);
    setPayback(0);
    onRequestClose();
  };

  const handleKeyDown = async (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Enter") {
      await handleSubmit();
    }
  }
  let init = true;

  useEffect(() => {
    if (isOpen) {
      if (init) {
        setTroco(0);
        setPayback(paybackValue);
        init = false;
      }
      inputTrocoRef.current?.focus();
      //inputTrocoRef.current?.select();

    }
  }, [isOpen]);
  setTimeout(() => {
    inputTrocoRef.current?.focus();
    //inputTrocoRef.current?.select();
  }, 50);



  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onRequestClose()}
      style={Styles.customStyles}
      contentLabel="Main Modal"
      ariaHideApp={false}
    >
      <MessageBox />
      <Styles.ModalWrapper
        tabIndex={-1}
        ref={modalWrapperRef}
        onKeyDown={handleKeyDown}
      >
        <Styles.ModalContent>
          <Styles.ModalHeader
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
            <Styles.ModalTitle>Confirme o Repique</Styles.ModalTitle>
            <Styles.ModalDescription>{`Confirme o troco para o valor pago em dinheiro.`}</Styles.ModalDescription>
          </Styles.ModalHeader>
          <Styles.ModalBody
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .backgroundColor
            }
          >
            <Styles.RowContainer>
              <Styles.FieldLabel>
                Troco:
              </Styles.FieldLabel>
              <Styles.FieldContainer>
                <Styles.TextInput
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  <input
                    type="text"
                    placeholder=""
                    ref={inputTrocoRef}
                    value={troco === 0 ? "" : String(troco.toFixed(2)).replace(".", ",")}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    onFocus={e => {
                      // Move cursor to start and select all for easy overwrite
                      e.target.setSelectionRange(0, e.target.value.length);
                    }}
                    onClick={e => {
                      // Always move cursor to start on click
                      e.currentTarget.setSelectionRange(0, 0);
                    }}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      // Remove all non-digit characters
                      const raw = e.target.value.replace(/\D/g, "");
                      // Parse as cents
                      const cents = raw ? parseInt(raw, 10) : 0;
                      const value = cents / 100;
                      setTroco(value);
                      setPayback(Number(paybackValue - value));
                    }}
                    onKeyPress={handleKeyPress}
                  />
                </Styles.TextInput>
              </Styles.FieldContainer>
            </Styles.RowContainer>
            <Styles.RowContainer>
              <Styles.FieldLabel>
                Repique:
              </Styles.FieldLabel>
              <Styles.FieldContainer>
                <Styles.TextInput
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  <input
                    type="text"
                    placeholder=""
                    value={String(payback.toFixed(2)).replace(".", ",")}
                    onKeyPress={handleKeyPress}
                  />
                </Styles.TextInput>
              </Styles.FieldContainer>
            </Styles.RowContainer>
          </Styles.ModalBody>
          <Styles.ModalFooter
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <div style={{ display: "flex" }}>
              <Styles.Button onClick={handleSubmit}>
                Confirmar
              </Styles.Button>
            </div>
          </Styles.ModalFooter>
        </Styles.ModalContent>
      </Styles.ModalWrapper>
    </Modal>
  );
};

export default PaybackModal;
